<template>
  <el-upload
    class="image-upload"
    v-bind="$attrs"
    :action="action"
    accept="image/jpeg,image/png,image/jpg"
    :show-file-list="false"
    :on-success="handleSuccess"
    :before-upload="beforeUpload"
    :on-progress="onProgress"
    :on-error="onError"
    :headers="headers"
  >
    <img v-if="imageUrl" :src="imageUrl" class="img" :style="uploadStyle">
    <i v-else class="el-icon-plus video-upload-icon" :style="{...uploadStyle, 'line-height': uploadStyle && uploadStyle.height}"/>
  </el-upload>
</template>

<script>

export default {
  name: 'UploadImage',
  props: {
    uploadStyle: {
      type: Object,
      detault: {
        width: '178px',
        height: '178px'
      }
    }
  },
  data() {
    return {
      headers: {
        token: this.$getToken()
      },
      action: this.$baseUrl + '/api/file/update.do',
      imageUrl: this.value,
      loading:null
    }
  },
  methods: {
    // 上传之前，可以做一些校验
    beforeUpload(file) {
      console.log('beforeUpload')
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!')
      }else{
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }
      return isLt5M
    },

    // 上传中
    onProgress() {
      console.log('onProgress')
      this.$emit('onProgress')
    },

    // 上传成功后的回调
    handleSuccess(res, file) {
      this.loading.close();
      console.log('success', res)
      if(res.code == 0){
        // this.imageUrl = URL.createObjectURL(file.raw);
        this.imageUrl = this.$isHttp(res.data.url);
        this.$emit('onSuccess', res.data.url)
      }else{
        this.$message.error(res.msg);
      }
    },

    // 上传失败后的回调
    onError() {
      this.loading.close();
      console.log('onError')
      this.$emit('onError')
    }
  }
}
</script>

<style scoped>
.image-upload ::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.image-upload ::v-deep .el-upload:hover {
  border-color: #409EFF;
}
.image-upload-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.img {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadImage/index.vue